import { useCallback, useMemo, useState } from "react";

import LoupeIcon from "@/assets/images/icons2/icon--loupe.svg?component";
import { Pagination } from "@/features/pagination/Pagination";
import { TextField2 } from "@/ui2/molecules/TextField";
import { usePagination } from "@/features/pagination/hooks/usePagination";

import { adaptCsmData } from "../helpers/adapters";
import { CsmTable } from "../(table)/CsmTable";
import { PAGE_SIZE } from "../constants";
import { useCsmList } from "../api/queries/useCsmList";

export function SuccessManagerPanel() {
  const [search, setSearch] = useState("");
  const { data, isLoading } = useCsmList();
  const { currentPage, onPageChange, resetPage } = usePagination();

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearch(e.target.value);
      resetPage();
    },
    [resetPage],
  );
  const textInputProps = useMemo(() => ({ onChange, value: search }), [onChange, search]);

  const rows = useMemo(() => adaptCsmData(data ?? [], search), [data, search]);
  const pageRows = useMemo(
    () => rows.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE),
    [rows, currentPage],
  );

  return (
    <div className="tw:relative tw:flex tw:flex-col tw:gap-4">
      <TextField2
        aria-label="Search by name"
        className="tw:ml-6 tw:w-50"
        icon={<LoupeIcon aria-hidden className="tw:size-5 tw:text-text-tertiary" />}
        mode="input"
        placeholder="Search"
        textInputProps={textInputProps}
      />

      <CsmTable isLoading={isLoading} rows={pageRows} />

      {!isLoading && rows.length > PAGE_SIZE && (
        <Pagination
          className="tw:absolute tw:right-0 tw:-bottom-14 tw:left-0 tw:justify-center"
          currentPage={currentPage}
          onPageChange={onPageChange}
          totalPages={Math.ceil(rows.length / PAGE_SIZE)}
        />
      )}
    </div>
  );
}
